import moment from 'moment-timezone';

// The Backend language is PHP which works with seconds instead of milliseconds.
// JavaScript Date objects represent a single moment in time in a platform-independent format. Date objects contain a Number that represents milliseconds since 1 January 1970 UTC.
// @see https://stackoverflow.com/questions/847185/convert-a-unix-timestamp-to-time-in-javascript
export const fromBackend = (unixTimestamp: number, timezone?: string) => {
  const dateTime = moment.unix(unixTimestamp);
  if (timezone) return dateTime.tz(timezone);
  return dateTime;
};

export const fromBackendToDate = (unixTimestamp: number) => new Date(unixTimestamp * 1000);
